import React from "react";
import { Link } from "react-router-dom";
import { NAV } from "../mock";

const BrandMark = ({ light = false }) => (
  <svg className="brand-mark" viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="22.5" stroke={light ? "rgba(255,255,255,0.7)" : "var(--sky)"} strokeWidth="1" />
    <circle cx="24" cy="24" r="16" stroke={light ? "rgba(255,255,255,0.35)" : "var(--line)"} strokeWidth="0.8" />
    {/* radiant sun rays */}
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i * Math.PI) / 6;
      const x1 = 24 + Math.cos(a) * 8;
      const y1 = 24 + Math.sin(a) * 8;
      const x2 = 24 + Math.cos(a) * 14;
      const y2 = 24 + Math.sin(a) * 14;
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={light ? "rgba(255,255,255,0.75)" : "var(--gold-strong)"} strokeWidth="0.9" strokeLinecap="round" />;
    })}
    {/* diamond core */}
    <path d="M24 17 L29 24 L24 31 L19 24 Z" fill="none" stroke={light ? "#fff" : "var(--sky)"} strokeWidth="1.1" strokeLinejoin="round" />
    <circle cx="24" cy="24" r="2" fill={light ? "#fff" : "var(--gold-strong)"} />
  </svg>
);

export default BrandMark;
